var windowSessionStorage = function() {
  if (!window.name) {
    window.name = Math.random().toString(36).substring(2, 11);
  }
  return {
    setItem: function(key, value) {
      sessionStorage.setItem(window.name + key, value);
    },
    getItem: function(key) {
      return sessionStorage.getItem(window.name + key);
    },
    removeItem: function(key) {
      sessionStorage.removeItem(window.name + key);
    },
    clear: function() {
      Object.keys(sessionStorage).filter((k) => k.startsWith(window.name)).forEach((k) => sessionStorage.removeItem(k));
    }
  };
}();
export {
  windowSessionStorage
};
//# sourceMappingURL=windowSessionStorage.js.map
